/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Final_TitleInputs */

const en_agb_final_title = /** @type {(inputs: Agb_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Final Provisions`)
};

const de_agb_final_title = /** @type {(inputs: Agb_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Schlussbestimmungen`)
};

const fr_agb_final_title = /** @type {(inputs: Agb_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Dispositions finales`)
};

const es_agb_final_title = /** @type {(inputs: Agb_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Disposiciones finales`)
};

const it_agb_final_title = /** @type {(inputs: Agb_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Disposizioni finali`)
};

const nl_agb_final_title = /** @type {(inputs: Agb_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Slotbepalingen`)
};

const pl_agb_final_title = /** @type {(inputs: Agb_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Postanowienia końcowe`)
};

const fi_agb_final_title = /** @type {(inputs: Agb_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Loppumääräykset`)
};

const da_agb_final_title = /** @type {(inputs: Agb_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Afsluttende bestemmelser`)
};

const sv_agb_final_title = /** @type {(inputs: Agb_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12. Slutbestämmelser`)
};

/**
* | output |
* | --- |
* | "12. Final Provisions" |
*
* @param {Agb_Final_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_final_title = /** @type {((inputs?: Agb_Final_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Final_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_final_title(inputs)
	if (locale === "fr") return fr_agb_final_title(inputs)
	if (locale === "es") return es_agb_final_title(inputs)
	if (locale === "it") return it_agb_final_title(inputs)
	if (locale === "nl") return nl_agb_final_title(inputs)
	if (locale === "pl") return pl_agb_final_title(inputs)
	if (locale === "fi") return fi_agb_final_title(inputs)
	if (locale === "da") return da_agb_final_title(inputs)
	if (locale === "sv") return sv_agb_final_title(inputs)
	return en_agb_final_title(inputs)
});